<!-- Data -->
<cdk-virtual-scroll-viewport
  *ngIf="!!entries; else loadingData"
  class="gd-chronology"
  [itemSize]="renderMode === RenderMode.SMALL ? 200 : 80">
  <div
    *cdkVirtualFor="let entry of entries; templateCacheSize: 0;"
    class="gd-chronology-item"
    [ngStyle]="{height: renderMode === RenderMode.SMALL ? '20rem' : '8rem'}">

    <!-- Date -->
    <div class="gd-chronology-item-date">
      {{ entry.date | dateDefault }}
    </div>

    <!-- Days since previous event -->
    <div class="gd-chronology-item-number">
      <div class="gd-chronology-item-number-text">
        {{ entry.daysSincePreviousEvent }}
      </div>
    </div>

    <!-- Info -->
    <div class="gd-chronology-item-text">
      {{ entry.type === Constants.CHRONOLOGY_ITEM_TYPE.FOLLOW_UP ? ('LNG_PAGE_VIEW_CHRONOLOGY_CHRONOLOGY_ITEM_TYPE_FOLLOW_UP' | translate) : '' }}
      {{ entry.label | translate:entry.translateData }}
    </div>

  </div>
</cdk-virtual-scroll-viewport>

<!-- Loading data -->
<ng-template
  #loadingData>
  <mat-progress-spinner
    diameter="32"
    mode="indeterminate"></mat-progress-spinner>
</ng-template>
